<template>
	<div class="hello" id="box">
		<!-- 顶部 -->
		<div class="title">
			<div>
				<img class="title_stylea" @mouseover="changeMask(true,'a')" @mouseout="changeMask(false,'a')" :id="'abc'+('a')" @click="homePage" src="../assets/left.png">
				<img class="title_style" src="../assets/logo.png">
			</div>
		</div>
		
		
		<div class="part_five">
			<div class="journalism">
				<div class="journalism_div" v-for="(item,index) in list">
					<div class="journalism_div_div">
						<img @mouseover="changeMask(true,index)" @mouseout="changeMask(false,index)" :id="'abc'+(index)" @click="checKmorea(item.id)" :src="'http://www.leadbio.com'+ item.image" alt="">
					</div>
					<div class="journalism_texta">{{item.title}}</div>
				</div>
			</div>
		</div>
		<div style="text-align: center;">
			<el-pagination :background="true" :pager-count="7"
				layout="prev, pager, next" @current-change="paginationa" :total="this.total*10">
			</el-pagination>
		</div>
		<div class="bottom">备案信息：浙ICP备2021028688号-2</div>
	</div>
</template>

<script>
	export default {
		name:"press",
		data() {
			return{
				list: [],
				total:1,
				limit: 15,
				page:1
			}
		},
		created() {
			this.journalism()
		},
		methods:{
			changeMask:function(b,index){
			    if(b){
			       	document.getElementById("abc"+index).style.cursor="pointer"; 
			    }else{
			        document.getElementById("abc"+index).style.cursor="wait"; 
				}
			},
			
			journalism() {
				this.$axios.request({
					method: "get",
					url: 'http://www.leadbio.com/api/product/index ',
				}).then((res) => {
					this.total = Math.ceil(parseFloat(res.data.data.total) / 15)
					this.list = res.data.data.data
				})
			},
			//页数
			paginationa(page) {
				this.page = page
				this.$axios.request({
					method: "get",
					url: 'http://www.leadbio.com/api/product/index',
					params: {
						page: this.page,
						limit: this.limit
					}
				}).then((res) => {
					this.list = res.data.data.data
				})
			},
			//详情跳转
			checKmorea(id) {
				this.$router.push({
					path: '/commodity',
					query: {
						id: id,
						type: 1
					}
				})
			},
			//返回首页
			homePage() {
				this.$router.push({
					path: '/',
				})
			}
		}
	}
</script>

<style scoped>
	.part_five {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 76px;
		margin-bottom: 40px;
	}
	
	.journalism {
		width: 86%;
		display: flex;
		/* justify-content: space-between; */
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
	
	}
	
	.journalism_div {
		text-align: center;
		width: 33%;
		margin-bottom: 30px;
		position: relative;
		/* border-bottom: 1px solid #C63530; */
	}
	.journalism_div_div{
		height: 160px;
	}
	.journalism_div div img{
		width: 50%;
	}
	.journalism_time {
		border-left: 3px solid #C63530;
		padding-left: 10px;
		font-size: 16px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 16px;
		margin-bottom: 30px;
	
	}
	
	.journalism_text {
		font-size: 18px;
		font-family: PingFang SC-Heavy, PingFang SC;
		font-weight: 800;
		color: #333333;
		line-height: 32px;
		margin-bottom: 30px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	
	.journalism_more {
		position: absolute;
		bottom: 40px;
		font-size: 15px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #C63530;
		line-height: 27px;
	}
	.title {
		z-index: +99999;
		position: fixed;
		top: 0;
		width: 100%;
		height: 66px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.11999999731779099);
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
	}
	
	.title div {
		height: 66px;
		display: flex;
		align-items: center;
		margin-left: 50px;
	}
	.title_stylea{
		width: 48px;
		height: 48px;
	}
	.title_style {
		width: 150px;
		margin-left: 20px;
	}
	.hello{
		width: 1400px;
		position: relative;
		min-height: 100vh;
		height: 100%;
	}
	.bottom {
		
		margin-top: 30%;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 38px;
			background: #C63530;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}
	
</style>



// WEBPACK FOOTER //
// src/components/products.vue